// @flow
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useRouter } from 'Client/router/useRouter';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import * as scrollToHash from 'Components/utils/scroll/scrollToHash';
import routingChange from 'Store/routing/routing.actions';
import { startLoading, endLoading } from 'Store/global-loader/globalLoader.action';
import { usePrevious } from 'Src/hooks/use-previous/usePrevious';
import { convertLocationToHref } from 'Utils/uri/uriUtils';

let hasNavigated: boolean = false;

export const RouteChangeListener = () => {
  const { history, location } = useRouter<UrlParams, GlobalQueryParams>();
  const dispatch = useDispatch();
  const previousLocation = usePrevious(location);
  const { isDesktop } = useContext(ResponsiveContext);
  const scrollUnderNav = !isDesktop;

  const href = convertLocationToHref(location);

  useEffect(
    () => {
      dispatch(routingChange());
      if (location.hash) {
        scrollToHash.goToHash(location.hash, scrollUnderNav);
      } else if (hasNavigated) {
        window.scrollTo(0, 0);
      }
    },
    [href, location.hash],
  );

  useEffect(() => {
    const showLoader = nextUri => {
      hasNavigated = true;

      // on the booking engine there is no loader between pages
      if (!(nextUri.startsWith('/booking/') && location.pathname.startsWith('/booking/'))) {
        if (nextUri.split('?')[0] === location.pathname.split('?')[0]) {
          dispatch(startLoading('', false));
        } else {
          // startLoading second arg it here to handle scroll correctly after navigation
          // see Components/widgets/loading/Loading.jsx
          dispatch(startLoading('', true));
        }
      }
    };
    const hideLoader = nextUri => {
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      if (
        hasNavigated &&
        !(nextUri.startsWith('/booking/') && previousLocation.pathname.startsWith('/booking/'))
      ) {
        dispatch(endLoading());
      }
    };
    // Show the loader before each page transition, hide after
    history.events.on('routeChangeStart', showLoader);
    history.events.on('routeChangeComplete', hideLoader);

    return () => {
      history.events.off('routeChangeStart', showLoader);
      history.events.off('routeChangeComplete', hideLoader);
    };
  });

  return null;
};
